import './index.scss';
import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Button from '~/components/button';
import GeniusSearch from '~/components/genius_search';
import useComponentVisible from '~/hooks/useComponentVisible';
import ClassificationResults from './results';
const ClassificationResultsFilter = ({ categories, selectedCategories, setSelectedCategories, descriptors, selectedDescriptors, setSelectedDescriptors, }) => {
    const { ref, isComponentVisible: isVisible, setIsComponentVisible: setIsVisible, } = useComponentVisible(false);
    const [filteredCategories, setFilteredCategories] = useState(categories);
    const [filteredDescriptors, setFilteredDescriptors] = useState(descriptors);
    const [searchText, setSearchText] = useState('');
    useEffect(() => {
        var _a;
        const pageContentBody = (_a = document.getElementsByClassName('page-content-wrapper')) === null || _a === void 0 ? void 0 : _a[0];
        isVisible
            ? pageContentBody.classList.add('opaque-background')
            : pageContentBody.classList.remove('opaque-background');
    }, [isVisible]);
    const handleSearch = value => {
        setFilteredCategories(categories.filter(x => x.toLowerCase().includes(value.toLowerCase())));
        setFilteredDescriptors(descriptors.filter(x => x.toLowerCase().includes(value.toLowerCase())));
    };
    const handleClearSelections = () => {
        setSelectedCategories([]);
        setSelectedDescriptors([]);
    };
    const overlayContent = (React.createElement(Popover, { className: 'classification-popover' },
        React.createElement("div", { className: 'classification-results-filter-ref', ref: ref },
            React.createElement(Popover.Title, null,
                React.createElement("h5", { className: 'text-center', style: { margin: '10px' } },
                    React.createElement("b", null, "FILTER RESULTS"))),
            React.createElement(Popover.Content, { className: 'classification-results-filter-content-container' },
                React.createElement("div", { className: 'action-container' },
                    React.createElement(GeniusSearch, { handleSearch: handleSearch, id: 'classification-filter-results-search', placeholder: 'Search to filter list below...', searchText: searchText, setSearchText: setSearchText }),
                    React.createElement(Button, { onClick: () => handleClearSelections(), title: 'Clear Selections' },
                        React.createElement("i", { className: 'fas fa-trash' }),
                        " Clear")),
                React.createElement(ClassificationResults, { filteredCategories: filteredCategories, selectedCategories: selectedCategories, setSelectedCategories: setSelectedCategories, filteredDescriptors: filteredDescriptors, selectedDescriptors: selectedDescriptors, setSelectedDescriptors: setSelectedDescriptors })))));
    return (React.createElement(OverlayTrigger, { placement: 'bottom', overlay: overlayContent, trigger: 'click', show: isVisible },
        React.createElement("span", { className: isVisible ? 'active' : '', onClick: () => setIsVisible(!isVisible) },
            React.createElement("span", { className: 'far fa-sliders-h' }))));
};
export default ClassificationResultsFilter;
